import React, { useRef, useState } from "react";
import classes from "./CreateQuestions.module.css";
import util from "../../styles/utilities.module.css";
import ProgressBarWithCircles from "../Layout/ProgressBar";
import LanguageSelector from "../CriteriaSubmission/languageSelector";

import CreateQuestionsForm from "./CreateQuestionsForm";
import GradeSelector from "./GradeSelector";
import DifficultySelector from "./DifficultySelector";
import { selectLanguage } from "../../slices/auth";
import Spinner from "../UI/spinner/spinner";
import {
  selectFormType,
  selectFormData,
  setFormData,
  selectTextID,
  setQuizID,
  setMcQuestions,
  setFfQuestions,
  setTfQuestions,
  setFbQuestions
} from "../../slices/form";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useAppUsageLogger,
  useGenerateAssessmentBatchMutation,
} from "../../slices/authApi";

const CreateQuestions = () => {
  const endRef = useRef(null);
  const formType = useSelector(selectFormType);
  const formData = useSelector(selectFormData);
  const { grade, difficulty_level } = formData || {};
  const navigate = useNavigate();
  const logAppUse = useAppUsageLogger();
  const textID = useSelector(selectTextID);
  const dispatch = useDispatch();
  const [errorMsg, setErrMsg] = useState("");
  const language = useSelector(selectLanguage);
  const [
    generateAssessmentBatch,
    { isLoading: isGenerateAssessmentBatchLoading },
  ] = useGenerateAssessmentBatchMutation();


  const backBtnClickHandler = () => {
    logAppUse("questions_criteria", "passage_review");
    navigate(-1);
  };

  const skillsToSend =
    formData.subject === "Math"
      ? {
          fluency: formData?.questions?.skills?.fluency,
          concept: formData?.questions?.skills?.concept,
          application: formData?.questions?.skills?.application,
          reasoning: formData?.questions?.skills?.reasoning,
        }
      : formData.show_text === "Open book"
      ? {
          analysis: formData?.questions?.skills?.analysis,
          structure: formData?.questions?.skills?.structure,
          theme: formData?.questions?.skills?.theme,
          tone: formData?.questions?.skills?.tone,
          vocabulary: formData?.questions?.skills?.vocabulary,
        }
      : {
          analysis: formData?.questions?.skills?.analysis,
          application: formData?.questions?.skills?.application,
          comprehension: formData?.questions?.skills?.comprehension,
          knowledge: formData?.questions?.skills?.knowledge,
        } || {};

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      formData?.questions?.ff_quantity > 25 ||
      formData?.questions?.ff_quantity < 0
    ) {
      setErrMsg("Please enter an integer between 0 and 25.");
    } else if (
      formData?.questions?.mc_quantity > 25 ||
      formData?.questions?.mc_quantity < 0
    ) {
      setErrMsg("Please enter an integer between 0 and 25.");
    } else if (
      formData?.questions?.tf_quantity > 25 ||
      formData?.questions?.tf_quantity < 0
    ) {
      setErrMsg("Please enter an integer between 0 and 25.");
    } else if (
      formData?.questions?.fb_quantity > 25 ||
      formData?.questions?.fb_quantity < 0
    ) {
      setErrMsg("Please enter an integer between 0 and 25.");
    }else {
      setErrMsg("");
      await logAppUse("questions_criteria", "questions_review");
      try {
        const assessmentBatchData = await generateAssessmentBatch({
          text_id: textID,
          show_text: formData.show_text,
          language: language,
          grade: formData.grade,
          template_type: formType,
          questions: {
            ff_quantity: formData.questions.ff_quantity,
            mc_options: formData.questions.mc_options,
            mc_quantity: formData.questions.mc_quantity,
            tf_quantity: formData.questions.tf_quantity,
            fb_quantity: formData.questions.fb_quantity,
            skills: skillsToSend,
            question_scope_passage_only: formData.questions.question_scope_passage_only,
          },
          assessment_instructions: formData?.assessment_instructions,
          text_instructions: formData?.text_instructions,
        });
        const quizID = assessmentBatchData?.data?.quiz_id;
        const mcQuestions = assessmentBatchData?.data?.mc_questions;
        const ffQuestions = assessmentBatchData?.data?.ff_questions;
        const tfQuestions = assessmentBatchData?.data?.tf_questions;
        const fbQuestions = assessmentBatchData?.data?.fb_questions;

        dispatch(setMcQuestions(mcQuestions));
        dispatch(setFfQuestions(ffQuestions));
        dispatch(setTfQuestions(tfQuestions));
        dispatch(setFbQuestions(fbQuestions));
        dispatch(setQuizID(quizID));

        navigate("/questionsReview");
      } catch (err) {
        if (!err?.status) {
          setErrMsg("No Server Response");
        } else if (err.status === 401) {
          setErrMsg("Unauthorized");
        } else {
          let err_message = "";
          if (err.data.message) {
            err_message = err.data.message;
          } else {
            err_message = err.status + " Server Error ";
          }
          setErrMsg(err_message);
        }
      }
    }
  };

  return (
  <div className={`page-margin ${classes.createQuestionsRoot}`}>
      {isGenerateAssessmentBatchLoading ? (
        <Spinner
          message={
            isGenerateAssessmentBatchLoading
              ? "We are hard at work creating your quiz. This may take a few minutes."
              : ""
          }
        />
      ) : null}
      <form onSubmit={submitHandler}>
        <section aria-label="question generation" className="app-main">
          <p style={{ fontSize: "larger", textAlign: "center" }}>
            <strong style={{ fontSize: "19px" }}>
              Next, tell us a bit more about the questions you'd like the AI to
              create.
            </strong>
            <br />
            We will generate questions that fit your specific needs.
          </p>
          <div style={{ paddingTop: "60px" }} />

          <ProgressBarWithCircles progress={75} />
          <LanguageSelector />
          <GradeSelector grade={grade} selectStoreData={selectFormData}/>
          <DifficultySelector difficultyLevel={difficulty_level} />
          <CreateQuestionsForm />

          <div style={{ marginTop: "50px" }}></div>
          {errorMsg ? (
            <div className={`${util.alert} ${util['alert--danger']}`}>{errorMsg}</div>
          ) : null}
          <div className={classes.navigationButtonsContainer} ref={endRef}>
            <div className={`${classes['form-actions']} ${classes['form-actions--flow']}`}>
              <button
                className={`${util.btn} ${util['btn--ghost']} ${classes.navigationButton}`}
                onClick={backBtnClickHandler}
                type="button"
              >
                Go back
              </button>

              <button
                className={`${util.btn} ${util['btn--secondary']} ${classes.navigationButton}`}
                name={"right"}
                disabled={!formType}
                type="submit"
              >
                Continue
              </button>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
};

export default CreateQuestions;
